import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _size from 'lodash/size';
import { fileType } from 'types';

import File from './components/File';

import './style.scss';

class List extends Component {
  static propTypes = {
    files: PropTypes.arrayOf(fileType),
    hasNameExceptions: PropTypes.bool,
    onAddFile: PropTypes.func,
    onDeleteFile: PropTypes.func,
    onDeleteFiles: PropTypes.func,
    onExportFile: PropTypes.func,
    onExportFiles: PropTypes.func,
    onOpenFile: PropTypes.func,
    onOpenFiles: PropTypes.func,
    onUpdateFile: PropTypes.func,
  };

  state = {
    rootSelectionIndex: 0,
    selections: [],
  };

  isSelected = file => this.state.selections.some(f => f.id === file.id);

  resetState = () => {
    this.setState({
      rootSelectionIndex: 0,
      selections: [],
    });
  };

  handleDeleteFiles = () => {
    this.props.onDeleteFiles(this.state.selections);
  };

  handleExportFiles = () => {
    this.props.onExportFiles(this.state.selections);
  };

  handleOpenFiles = async () => {
    await this.props.onOpenFiles(this.state.selections);
    this.resetState();
  };

  handleSelection = (e, file) => {
    const { shiftKey, altKey } = e.nativeEvent;
    const { rootSelectionIndex } = this.state;
    const fileIndex = this.props.files.findIndex(f => f.id === file.id);
    let newSelections = [];

    if (altKey) {
      if (!this.isSelected(file)) {
        this.setState(prevState => ({
          selections: [...prevState.selections, file],
          rootSelectionIndex: fileIndex,
        }));
      } else {
        this.setState(prevState => ({
          selections: prevState.selections.filter(({ id }) => id !== file.id),
          rootSelectionIndex: 0,
        }));
      }
    } else if (shiftKey) {
      if (fileIndex > rootSelectionIndex) {
        this.props.files.forEach((f, i) => {
          if (i >= rootSelectionIndex && i <= fileIndex) {
            newSelections = [...newSelections, f];
          }
        });
      } else {
        this.props.files.forEach((f, i) => {
          if (i <= rootSelectionIndex && i >= fileIndex) {
            newSelections = [...newSelections, f];
          }
        });
      }
      this.setState({
        selections: newSelections,
      });
    } else {
      this.setState({
        selections: [file],
        rootSelectionIndex: fileIndex,
      });
    }
  };

  render() {
    const {
      files,
      hasNameExceptions,
      onDeleteFile,
      onUpdateFile,
      onAddFile,
      onOpenFile,
      onExportFile,
    } = this.props;
    const selectionsCount = _size(this.state.selections);

    return (
      <ul data-test="file-list" styleName="list">
        {files.map(file => (
          <File
            key={file.id}
            data-test={file.id}
            file={file}
            files={files}
            hasNameExceptions={hasNameExceptions}
            isSelected={this.isSelected(file)}
            selectionsCount={selectionsCount}
            onAddFile={onAddFile}
            onDeleteFile={onDeleteFile}
            onDeleteFiles={this.handleDeleteFiles}
            onExportFile={onExportFile}
            onExportFiles={this.handleExportFiles}
            onOpenFile={onOpenFile}
            onOpenFiles={this.handleOpenFiles}
            onResetState={this.resetState}
            onToggleSelection={this.handleSelection}
            onUpdateFile={onUpdateFile}
          />
        ))}
      </ul>
    );
  }
}
export default List;
